import { TabState } from '@interfaces/open-positions.model';
import { EmeraldBadgeSize } from '@emerald/nxcore';

export const paginationParams = {
  enabled: true,
  pageSize: 10,
  pageSizeOptions: [5, 10, 20],
};

export const paginationTimesheetParams = {
  enabled: true,
  pageSize: 10,
  pageSizeOptions: [5, 10, 20, 50, 100],
};


export const tabsData: TabState[] = [
  {
    label: 'Open positions',
    isTabActive: true,
    value: 'Open positions',
    badgeSize: EmeraldBadgeSize.SMALL,
    hasBadge: true,
    activeTab: true,
    positionsCount: 0,
    candidatesCount: 0,
  },
  {
    label: 'Candidates',
    isTabActive: false,
    value: 'candidates',
    badgeSize: EmeraldBadgeSize.SMALL,
    hasBadge: true,
    activeTab: false,
    positionsCount: 0,
    candidatesCount: 0,
  },
];
